<template>
  <Record
    class="LaptopAlternative">
    <div slot="title" class="title">
      {{ laptop.name }}
    </div>
    <Row>
      <Column
        v-for="{ label, score, scoreClass, value } in laptopSpecs"
        :key="label"
        :md="6">
        <LaptopSpec
          :label="label"
          :score="score"
          :scoreClass="scoreClass"
          :value="value" />
      </Column>
    </Row>
    <Tag
      v-if="laptop.isArchived"
      slot="actions"
      class="danger">
      {{ $t('archived') }}
    </Tag>
    <div slot="actions">
      <Row>
        <Column :md="6">
          <Btn class="xs danger inv" @click="$emit('remove')">
            {{ $t('removeAlternative') }}
          </Btn>
        </Column>
        <Column :md="6">
          <Route class="Btn xs inv" :to="{ hash: `#RecordArticleLaptop-${laptop.id}` }">
            {{ $t('scrollTo') }}
          </Route>
        </Column>
      </Row>
    </div>
  </Record>
</template>

<script>
import LaptopSpec from './LaptopSpec'

export default {
  components: {
    LaptopSpec,
  },
  props: {
    laptop: Object,
  },
  computed: {
    laptopSpecs() {
      const dollars = price => price
        ? this.$options.filters.currency(price, '$', 0)
        : this.$options.filters.fallback(price)

      return [
        {
          label: this.$t('score'),
          score: this.laptop.totalScore,
          value: this.$options.filters.nth(this.laptop.totalScoreNth),
        },
        {
          label: this.$t('price'),
          score: this.laptop.valueScore,
          value: dollars(this.laptop.price),
        },
      ]
    },
  },
}
</script>

<style lang="scss">
.LaptopAlternative {
  .title {
    @include ellipsis;
  }
}
</style>

<i18n>
{
  "en": {
    "archived": "Archived",
    "price": "Price",
    "removeAlternative": "Remove",
    "score": "Score",
    "scrollTo": "Scroll to laptop"
  }
}
</i18n>
